<template>
  <div class="app-content">
    <Navbar />
    <div class="">
      <div
        class="w-full flex flex-wrap justify-center items-center text-white"
        style="min-height: 80vh"
      >
        <div class="h-100 px-10 lg:flex items-center">
          <div class="lg:w-2/6 md:px-10 lg:px-32">
            <h1
              class="text-3xl md:text-4xl lg:text-4xl mb-10 lg:mb-0 leading-none font-bold"
            >
              Subscribe
            </h1>
          </div>
          <div class="lg:w-4/6">
            <div
              class="md:block text-center md:text-left md:text-md lg:text-lg font-medium w-full"
            >
              <div class="timeline lg:mt-10">
                <div class="entry">
                  <div class="title w-full md:w-1/3">
                    <router-link
                      to="/login?plan=monthly"
                      class="btn mx-2 py-2 px-4 text-center md:px-6 md:py-2 mt-1 inline-block rounded-full text-white focus:outline-none hover:bg-custom hover:text-black"
                      >Get Started</router-link
                    >
                  </div>
                  <div class="body w-full md:w-2/3">
                    <h4 class="text-custom text-2xl md:text-3xl font-bold">
                      $59.95 Monthly
                    </h4>
                    <ul>
                      <li>Receive at least 1-2 SPYOWS signals</li>
                      <li>
                        Each SPYOWS signal is delivered by either Email or via
                        SMS alert based
                      </li>
                      <li>Receive alerts for trades for consideration</li>
                      <li>Buy or Signal may have Limited time to execute.</li>
                      <li>Automatic Renewal Monthly unless cancelled.</li>
                    </ul>
                  </div>
                </div>
                <div class="entry">
                  <div class="title w-full md:w-1/3">
                    <router-link
                      to="/login?plan=yearly"
                      class="btn mx-2 py-2 px-4 text-center md:px-6 md:py-2 mt-1 inline-block rounded-full text-white focus:outline-none hover:bg-custom hover:text-black"
                      >Get Started</router-link
                    >
                  </div>
                  <div class="body w-full md:w-2/3">
                    <h4 class="text-custom text-2xl md:text-3xl font-bold">
                      $595.95 Yearly
                    </h4>
                    <ul>
                      <li>Receive at least 24 SPYOWS signals</li>
                      <li>
                        Each SPYOWS signal is delivered by either Email or via
                        SMS alert based
                      </li>
                      <li>Receive alerts for trades for consideration</li>
                      <li>Buy or Signal may have Limited time to execute.</li>
                      <li>Automatic Renewal Monthly unless cancelled.</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer>Accurate Signals</Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/layout/Nav.vue";
import Footer from "@/components/layout/Footer.vue";
// import Slider from "@/components/Slider.vue";
import Helper from "@/providers/helper";

export default {
  name: "Subscribe",
  metaInfo: {
    title: "Spyows",
    titleTemplate: "%s | Subscribe",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: {
    Navbar,
    Footer
  },
  created(){}
};
</script>
